<template>
    <div class="kgk-user-details">
        <div v-if="loading" class="kgk-loading-indicator"><i class="fas fa-spinner fa-spin"></i></div>
        <div v-else-if="error">
            <p>Fehler: {{error}}</p>
        </div>
        <div v-else>
            <div v-if="user">
                <UserAvatarUpload type="avatar" @uploaded="handleFileUploaded" :avatar-url="user.avatar_url" />

                <h1>{{ user.username }}</h1>
                <p>{{ user.prename }} {{ user.surname }}</p>
                <p>{{ user.city }}</p>
                <p>{{ user.email }}</p>
                <p>{{ user.verified_16 }}</p>

                <UserCompany :user="user" @forceRefresh="loadUserDetails" />

                <h2>Meine Urkunden</h2>
                <MyCertificates />

            </div>

            <div v-if="isCompanyAdmin">
                <div class="kgk-user-details-action-bar">
                    <router-link to="/manage/company" tag="button" type="button">
                        <i class="fas fa-building fa-fw"></i>
                        <span class="button-text">Firmenmanager</span>
                    </router-link>
                </div>
            </div>

            <div>
                <h2>Wähle aus, wie du Kilometer spenden möchtest</h2>
                <div v-if="loadingCompetitive" class="kgk-loading-indicator"><i class="fas fa-spinner fa-spin"></i></div>
                <div v-else class="kgk-mode-select">
                    <ul>
                        <li>
                            <label>
                                <input type="radio" value="0" v-model="competingMode">
                                <p style="font-size:12px">Du spendest Kilometer ohne Wettbewerb mit anderen Teilnehmern. Deine Läufe werden auch ohne Verifizierung gewertet, du erhältst aber keine Position in der Rangliste.</p>
                            </label>
                        </li>
                        <li>
                            <label>
                                <input type="radio" value="1" v-model="competingMode">
                                <p style="font-size:12px">Du misst dich im Wettbewerb mit anderen Läufern und Teams.
                                Du wirst in der Rangliste geführt, es werden dafür aber nur verifizierte Läufe gewertet.</p>
                            </label>
                        </li>
                    </ul>
                    <!--div style="text-align:center">
                        <button type="button" :disabled="competitive.value === competitive.initialValue || competitive.loading" @click.prevent="updateCompetitive">
                            <i class="fas " :class="{'fa-save': !competitive.loading, 'fa-spin fa-spinner': competitive.loading}"></i>
                            <span class="button-text">Speichern</span>
                        </button-->
                    </div>
                </div>
            </div>

            <div>
                <h2>Wähle deinen Eintragungsmodus</h2>
                <p v-if="!user.run_mode_chosen_at" style="font-size:12px;color:#dd0000;">Bitte wähle aus, ob du Läufe oder Schritte eintragen möchtest, bevor du deinen ersten Eintrag hinzufügst.</p>
                <p v-else style="font-size:12px;">Achtung: Beim Wechsel werden bisherige Einträge des jeweils anderen Modus von der Gesamtwertung ausgeschlossen (bleiben aber in deiner Läufe-Übersicht sichtbar).</p>
                <div v-if="loadingRunMode" class="kgk-loading-indicator"><i class="fas fa-spinner fa-spin"></i></div>
                <div v-else class="kgk-mode-select">
                    <ul>
                        <li>
                            <label>
                                <input type="radio" value="0" v-model="runMode">
                                <p style="font-size:12px">Läufe eintragen</p>
                            </label>
                        </li>
                        <li>
                            <label>
                                <input type="radio" value="1" v-model="runMode">
                                <p style="font-size:12px">Schritte eintragen</p>
                            </label>
                        </li>
                    </ul>
                </div>
            </div>

            <div v-if="isAdmin">
                <br />
                Administrator: Ja
                <br />
                <br />
                <!-- <div class="kgk-user-details-action-bar">
                    <router-link to="/admin/runs" tag="button" type="button">
                        <i class="fas fa-camera fa-fw"></i>
                        <span class="button-text">Admin: Laufnachweise</span>
                    </router-link>
                </div> -->

                <!-- <div class="kgk-user-details-action-bar">
                    <router-link to="/admin/companies" tag="button" type="button">
                        <i class="fas fa-building fa-fw"></i>
                        <span class="button-text">Admin: Firmenmanager</span>
                    </router-link>
                </div> -->

                <!-- <div class="kgk-user-details-action-bar">
                    <button type="button" :disabled="loadingDownloadExport" @click.prevent="downloadExportUsers">
                        <i class="fas fa-fw" :class="{'fa-download': !loadingDownloadExport, 'fa-spin fa-spinner': loadingDownloadExport}"></i>
                        <span class="button-text">Admin: Export Läuferdaten</span>
                    </button>
                </div>

                <div class="kgk-user-details-action-bar">
                    <router-link to="/admin/text" tag="button" type="button">
                        <i class="fas fa-font fa-fw"></i>
                        <span class="button-text">Admin: Textmanager</span>
                    </router-link>
                </div> -->

                <!--div class="kgk-user-details-action-bar">
                    <button type="button" :disabled="loadingCleanupOldData" @click.prevent="cleanupOldData">
                        <i class="fas fa-fw" :class="{'fa-download': !loadingCleanupOldData, 'fa-spin fa-spinner': loadingCleanupOldData}"></i>
                        <span class="button-text">Admin: Cleanup Old Data (1 Jahr alte Bilder zu läufen.)</span>
                    </button>
                </div-->
            </div>

            <div class="spacer"></div>

            <div class="kgk-user-details-action-bar">
                <button type="button" @click.prevent="changeProfile" ref="changeProfileButton" id="changeProfileButton">
                    <i class="fas fa-user-edit"></i>
                    <span class="button-text">Profil bearbeiten</span>
                </button>

                <button type="button" @click.prevent="changePassword">
                    <i class="fas fa-key"></i>
                    <span class="button-text">Passwort ändern</span>
                </button>

                <button type="button" @click.prevent="changeMail">
                    <i class="fas fa-envelope"></i>
                    <span class="button-text">E-Mail ändern</span>
                </button>

                <button type="button" class="kgk-button-danger" @click.prevent="deleteAccount">
                    <i class="fas fa-user-times"></i>
                    <span class="button-text">Konto löschen</span>
                </button>

                <ConnectStrava />
            </div>
    </div>
</template>

<script>
    import user from '../../api/user';
    //import admin from '../../api/admin';

    import SessionHandling from './../../session-handling';

    //import TeamInvite from './TeamInvite';
    import UserChangePasswordForm from './UserChangePasswordForm';
    import UserChangeEmailForm from './UserChangeEmailForm';
    import UserChangeProfileForm from './UserChangeProfileForm';
    import UserDeleteAccountForm from './UserDeleteAccountForm';
    import UserAvatarUpload from './UserAvatarUpload';
    import ConnectStrava from './ConnectStrava.vue';

    import UserCompany from '@/components/user/UserCompany';
    import MyCertificates from '@/components/user/MyCertificates';
    import donateModal from '@/helpers/donate-modal';
    import popupMessageModal from '@/helpers/popup-message-modal';
    import router from '../../router';

    import { useRoute } from 'vue-router';

    export default {
        name: 'UserDetails',
        components: {
            UserAvatarUpload,
            UserCompany,
            MyCertificates,
            ConnectStrava,
        },
        props: {
            //msg: String,
        },
        data() {
            return {
                user: '',
                loading: false,
                loadingCompetitive:false,
                loadingRunMode: false,
                error: null,
                loadingDownloadExport: false,
                acceptCompanyInviteMass: false,
            }
        },
        computed: {
            isAdmin() {
                return typeof this.user !== 'undefined' && this.user && typeof this.user.admin !== 'undefined' && this.user.admin;
            },
            isCompanyAdmin() {
                return typeof this.user !== 'undefined' && this.user && typeof this.user.companyAdmin !== 'undefined' && this.user.companyAdmin;
            },
            // The former 3rd option (value 2 / run_type=1, "Company Challenge")
            // is gone -- that opt-in now happens implicitly by logging a run
            // via steps (see CreateRunStepsForm.vue), not as a separate
            // competing mode here. run_type is always cleared to null.
            competingMode: {
                get() {
                    return this.user.competitive ? 1 : 0;
                },
                set(value) {
                    this.user.competitive = value == 1 ? 1 : 0;
                    this.user.run_type = null;
                    this.changeRunType();
                }
                },
            userIsLoggedIn(){
                return this.user && !!this.user.identifier;
            },
            runMode: {
                get() {
                    return this.user.run_mode === 1 ? 1 : 0;
                },
                set(value) {
                    this.user.run_mode = value == 1 ? 1 : 0;
                    this.changeRunMode();
                }
            },
        },
        methods: {
            clearCompany() {
                this.user.companyData = null;
            },
            onCompanySelected(/*companyData*/) {
                //console.log('onCompanySelected', JSON.stringify(companyData));
                //this.form.companyData = companyData;
            },

            changeRunType(){
                this.loadingCompetitive = true;
                const competitive = {competitive: parseInt(this.user.competitive), run_type: this.user.run_type};
                user.updateCompetitive(
                    this,
                    competitive,
                    () => {
                    },
                    () => alert('Es ist ein Fehler aufgetreten'),
                    () => this.loadingCompetitive = false,
                );
            },

            changeRunMode(){
                this.loadingRunMode = true;
                user.updateRunMode(
                    this,
                    this.user.run_mode,
                    () => {
                        this.user.run_mode_chosen_at = new Date().toISOString();

                        // CreateRun.vue reads its user prop from App.vue's own,
                        // separately-fetched copy (:user="$parent.user" on
                        // Runs.vue) -- without this, the run/steps upload
                        // buttons would keep showing the pre-switch state until
                        // a full page reload re-fetches everything.
                        if (this.$parent && this.$parent.$parent && this.$parent.$parent.user) {
                            this.$parent.$parent.user.run_mode = this.user.run_mode;
                            this.$parent.$parent.user.run_mode_chosen_at = this.user.run_mode_chosen_at;
                        }

                        this.$notify({
                            type: 'success',
                            title: 'Eintragungsmodus geändert',
                            text: 'Dein Eintragungsmodus wurde erfolgreich geändert.'
                        });
                    },
                    () => alert('Es ist ein Fehler aufgetreten'),
                    () => this.loadingRunMode = false,
                );
            },

            loadUserDetails() {
                this.loading = true;

                user.getDetails(
                    this,
                    data => {
                        this.user = data.user;
                        //console.log('test');
                        //console.log(this.user);
                        this.checkIfRedirectNeeded();

                        donateModal.openDonateModalIfNeeded(this.$modal, this.user);
                        popupMessageModal.showPopupMessagesIfNeeded(this.$modal);
                        if(this.$route.query.jumpto === 'vaj' && !this.user.verify_age){
                            this.$refs.changeProfileButton.click();
                        }
                    },
                    () => this.error = 'Es ist ein Fehler aufgetreten',
                    () => {
                        this.loading = false
                        this.checkIfRedirectNeeded();
                    },
                );
            },


            handleFileUploaded(url/*, ext*/) {
                this.user.avatar_url = url + '?' + (new Date().getTime());
            },


            changePassword() {
                const _this = this;

                const modalSaveTrigger = {
                    trigger: 0
                };

                const saveButtonText = 'Passwort ändern';
                const saveButton = {
                    title: saveButtonText,
                    handler() {
                        ++modalSaveTrigger.trigger;
                    },
                    default: true,
                };

                this.$modal.show('dialog', {
                    title: 'Passwort ändern',
                    component: UserChangePasswordForm,
                    props: {
                        insideModal: true,
                        modalSaveTrigger: modalSaveTrigger
                    },
                    on: {
                        changed: _this.handlePasswordChanged,
                        loadingStarted() {
                            saveButton.title = saveButtonText + ' <i class="fas fa-spinner fa-spin"></i>';
                        },
                        loadingEnded() {
                            saveButton.title = saveButtonText;
                        },
                        modalForceClose() {
                            _this.$modal.hide('dialog');
                        }
                    },
                    buttons: [
                        {
                            title: 'Abbrechen',
                            /*handler() {
                                _this.$modal.hide('dialog');
                            }*/
                        },
                        saveButton
                    ]
                });
            },
            handlePasswordChanged() {
                //console.log('handleSelection', selectedUsers, this);
                //this.selection = selectedUsers;

                this.$modal.hide('dialog');
            },


            changeMail() {
                const _this = this;

                const modalSaveTrigger = {
                    trigger: 0
                };

                const saveButtonText = 'E-Mail ändern';
                const saveButton = {
                    title: saveButtonText,
                    handler() {
                        ++modalSaveTrigger.trigger;
                    },
                    default: true,
                };

                this.$modal.show('dialog', {
                    title: 'E-Mail-Adresse ändern',
                    component: UserChangeEmailForm,
                    props: {
                        insideModal: true,
                        modalSaveTrigger: modalSaveTrigger,
                        currentEmail: this.user.email,
                    },
                    on: {
                        changed: _this.handleMailChanged,
                        loadingStarted() {
                            saveButton.title = saveButtonText + ' <i class="fas fa-spinner fa-spin"></i>';
                        },
                        loadingEnded() {
                            saveButton.title = saveButtonText;
                        },
                        modalForceClose() {
                            _this.$modal.hide('dialog');
                        }
                    },
                    buttons: [
                        {
                            title: 'Abbrechen',
                            /*handler() {
                                _this.$modal.hide('dialog');
                            }*/
                        },
                        saveButton
                    ]
                });
            },
            handleMailChanged() {
                //console.log('handleSelection', selectedUsers, this);
                //this.selection = selectedUsers;

                this.$modal.hide('dialog');

                this.loadUserDetails();
            },


            changeProfile() {
                const _this = this;

                const modalSaveTrigger = {
                    trigger: 0
                };

                const saveButtonText = 'Profil speichern';
                const saveButton = {
                    title: saveButtonText,
                    handler() {
                        ++modalSaveTrigger.trigger;
                    },
                    default: true,
                };

                this.$modal.show('dialog', {
                    title: 'Profil ändern',
                    component: UserChangeProfileForm,
                    props: {
                        insideModal: true,
                        modalSaveTrigger: modalSaveTrigger,
                        user: this.user,
                    },
                    on: {
                        changed: _this.handleMailChanged,
                        loadingStarted() {
                            saveButton.title = saveButtonText + ' <i class="fas fa-spinner fa-spin"></i>';
                        },
                        loadingEnded() {
                            saveButton.title = saveButtonText;
                        },
                        modalForceClose() {
                            _this.$modal.hide('dialog');
                        }
                    },
                    buttons: [
                        {
                            title: 'Abbrechen',
                            /*handler() {
                                _this.$modal.hide('dialog');
                            }*/
                        },
                        saveButton
                    ]
                });
            },
            handleProfileChanged() {
                //console.log('handleSelection', selectedUsers, this);
                //this.selection = selectedUsers;

                this.$modal.hide('dialog');

                this.loadUserDetails();
            },

            deleteAccount() {
                const _this = this;

                const modalSaveTrigger = {
                    trigger: 0
                };

                const saveButtonText = 'Konto löschen';
                const saveButton = {
                    title: saveButtonText,
                    handler() {
                        ++modalSaveTrigger.trigger;
                    },
                    default: true,
                };

                this.$modal.show('dialog', {
                    title: 'Konto löschen',
                    component: UserDeleteAccountForm,
                    props: {
                        insideModal: true,
                        modalSaveTrigger: modalSaveTrigger,
                    },
                    on: {
                        deleted: _this.handleAccountDeleted,
                        loadingStarted() {
                            saveButton.title = saveButtonText + ' <i class="fas fa-spinner fa-spin"></i>';
                        },
                        loadingEnded() {
                            saveButton.title = saveButtonText;
                        },
                        modalForceClose() {
                            _this.$modal.hide('dialog');
                        }
                    },
                    buttons: [
                        {
                            title: 'Abbrechen',
                        },
                        saveButton
                    ]
                });
            },
            handleAccountDeleted() {
                this.$modal.hide('dialog');

                SessionHandling.logout();
                this.$parent.$parent.resetUserOnLogout();

                this.$notify({
                    type: 'success',
                    title: 'Konto gelöscht',
                    text: 'Dein Konto wurde erfolgreich gelöscht.'
                });

                router.push('/login');
            },

            downloadExportUsers() {
                this.loadingDownloadExport = true;

                const xhr = new XMLHttpRequest();

                xhr.open('POST', window.kgkRoutes.admin.exportUsers);
                xhr.onreadystatechange = handler;
                xhr.responseType = 'blob';
                xhr.setRequestHeader('Authorization', SessionHandling.getAuthorizationHeaderValue());
                xhr.send();

                const _this = this;

                function handler() {
                    if (this.readyState === this.DONE) {
                        _this.loadingDownloadExport = false;

                        if (this.status === 200) {
                            // this.response is a Blob, because we set responseType above
                            const dataUrl = URL.createObjectURL(this.response);

                            const filename = (new Date()).toISOString().slice(0, 10) + '_Teilnehmerexport.xlsx';

                            const link = document.createElement('a');
                            link.setAttribute('href', dataUrl);
                            link.setAttribute('download', filename);
                            link.setAttribute('style', 'display:none');
                            document.body.appendChild(link);
                            link.click();

                            URL.revokeObjectURL(dataUrl);
                        } else {
                            console.error('no export file');
                            alert('Es ist ein Fehler aufgetreten.');
                        }
                    }
                }
            },
            activateStravaSynchronization() {
                //todo: post request to endpoint with parameters

                this.loading = true;
                strava.activateStrava(
                    this,
                    data => {
                        this.user = data.user;
                    },
                    () => this.error = 'Es ist ein Fehler aufgetreten',
                    () => this.loading = false,
                );

            },
            cleanupOldData() {

            },
            checkIfRedirectNeeded(){
                
                if(this.$route.params.jumpto == "acceptCompanyInviteMass"){
                    this.acceptCompanyInviteMass = true;
                    this.inviteId = this.$route.params.inviteId;
                }
                
            
                console.log(this.user.identifier);
                if(!this.userIsLoggedIn){
                    this.$parent.$parent.redirectAfterLogin = true;
                    this.$parent.$parent.redirectAfterLoginTo = this.$route.path;
                    this.$router.push('/login');
                    
                }else{
                    if(this.acceptCompanyInviteMass){
                        this.acceptInvite(this.inviteId);
                    }
                }
            },
            acceptInvite(inviteId) {

                console.log('accepting invite!')
                
                user.acceptCompanyInviteMass(
                    this,
                    inviteId,
                    () => {
                        //console.log(data);

                        this.$notify({
                            type: 'success',
                            title: 'Einladung angenommen',
                            text: `Du bist nun als Mitarbeiter*in dieser Firma registriert.`
                        });

                        this.$router.push('/profile');
                        this.$router.go(0);
                        this.$nextTick(() => {
                            this.$notify({
                                type: 'success',
                                title: 'Einladung angenommen',
                                text: `Du bist nun Mitarbeiter*in dieser Firma.`
                            });
                        });
                    },
                    e => {
                        //console.error(e.response.status);
                        if( e.response.status == 400 ) {
                            /*if( typeof e.response.data.field !== 'undefined' ) {
                                // maybe highlight error field
                            }*/

                            this.$notify({
                                type: 'error',
                                title: 'Fehler',
                                text: e.response.data.message
                            });
                            return;
                        }

                        this.$notify({
                            type: 'error',
                            title: 'Es ist ein unbekannter Fehler aufgetreten.',
                            text: 'Bitte versuch es noch einmal.'
                        });
                        console.log(e)
                    },
                );
            },
        },
        mounted() {
            this.loadUserDetails();
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<!--<style scoped lang="scss">
    h3 {
        margin: 40px 0 0;
    }
    ul {
        list-style-type: none;
        padding: 0;
    }
    li {
        display: inline-block;
        margin: 0 10px;
    }
    a {
        color: #42b983;
    }
</style>-->
